<template>
  <div>
    <div style="display: flex; flex-direction: row; flex-wrap: wrap; gap: 3em">
      <div style="display: flex; flex-direction: column;">
        <div
          v-if="date"
          v-show="false"
          style="visibility: collapse"
        >
          <div class="text-primary">
            <label for="example-input">Дата:</label>
            <b-input-group class="mb-1">
              <b-form-input
                id="example-input"
                v-model="date"
                type="text"
                placeholder="ДД.ММ.ГГГГ"
                autocomplete="off"
              />
              <b-input-group-append>
                <b-form-datepicker
                  v-model="date"
                  size="sm"
                  button-only
                  locale="ru-RU"
                  aria-controls="example-input"
                />
              </b-input-group-append>
            </b-input-group>
          </div>
        </div>
        <v-calendar
          v-model="selectedDate"
          :attributes="attrs"
          @dayclick="onDayClick"
          @update:fromPage="onMonthChange"
        />
      </div>
      <div
        v-if="qrySaldo"
        style="align-content: flex-end;"
      >
        <table
          class="tbl"
          :style="loadingRates?'opacity: 0.2':''"
        >
          <thead>
            <tr style="border-bottom: solid black 1px;">
              <th>Валюта</th>
              <th>Курс</th>
              <th>Сумма в валюте</th>
              <th>Сумма в KZT</th>
              <th>Сумма в USD</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="cur in currencies()"
              :key="cur.curname.value"
            >
              <td style="text-align: center;">
                {{ cur.curname.value }}
              </td>
              <td style="text-align: right;">
                {{ cur.fxrate.value }}
              </td>
              <td style="text-align: right;">
                {{ totalAmountCur(cur.currency.value).toLocaleString() }}
              </td>
              <td style="text-align: right;">
                {{ totalAmountCurKzt(cur.currency.value).toLocaleString() }}
              </td>
              <td style="text-align: right;">
                {{ totalAmountCurUsd(cur.currency.value).toLocaleString() }}
              </td>
            </tr>
            <tr style="border-top: solid black 1px;">
              <td><b>ВСЕГО</b></td>
              <td />
              <td />
              <td style="text-align: right;">
                <b>{{ totalAmountKzt().toLocaleString() }}</b>
              </td>
              <td style="text-align: right;">
                <b>{{ totalAmountUsd().toLocaleString() }}</b>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        v-if="qrySaldo && !loadingData"
        style="display: flex; flex-direction: column; align-content: flex-end;"
      >
        <b-button
          v-if="this.cache.length > 0"
          variant="success"
          @click="saveCache()"
        >
          <feather-icon icon="SaveIcon" />&nbsp; Сохранить
        </b-button>
        <b-button
          v-if="hasSavedSaldo() && !isProtected()"
          style="margin-top: 0.3rem;"
          variant="outline-primary"
          @click="protectSaldo"
        >
          <feather-icon icon="LockIcon" />&nbsp; Защитить от изменений
        </b-button>
        <b-button
          v-if="isProtected()"
          style="margin-top: 0.3rem;"
          variant="outline-warning"
          @click="unprotectSaldo"
        >
          <feather-icon icon="UnlockIcon" />&nbsp; Снять защиту
        </b-button>
        <b-button
          v-if="hasSavedSaldo() && !isProtected()"
          style="margin-top: 0.3rem;"
          variant="danger"
          @click="deleteSaldo"
        >
          <feather-icon icon="Trash2Icon" />&nbsp; Удалить остатки
        </b-button>
        <b-button
          v-if="
            !hasSavedSaldo()
              && !isProtected()
              && changedElements.length === 0
              && closestFilledDate
          "
          style="margin-top: 0.3rem;"
          variant="info"
          @click="copySaldoFromPreviousDate"
        >
          <feather-icon icon="CopyIcon" />
          <feather-icon icon="ArrowRightIcon" />&nbsp; Перенести сальдо с {{ closestFilledDateHuman() }}
        </b-button>
      </div>
    </div>

    <div
      v-if="dataReady"
      style="margin-top: 2rem; overflow: scroll"
    >
      <table
        class="table table-bordered tbl"
        :style="loadingData?'opacity: 0.2':''"
      >
        <thead>
          <tr>
            <th>ID</th>
            <th>Код</th>
            <th>Наименование</th>
            <th>Тип счета</th>
            <th>Валюта</th>
            <th>Сумма в валюте счета</th>
            <th>Сумма в KZT</th>
            <th>Ставка по депозиту</th>
            <th>Начало депозита</th>
            <th>Окончание депозита</th>
            <th>Рейтинг S&P</th>
            <th>IBAN</th>
            <th>Описание</th>
          </tr>
        </thead>
        <tbody
          v-for="bank in qryBank.recordset.records"
          :key="bank.id.value"
        >
          <tr style="background-color: lightcyan;">
            <td>
              <span
                style="cursor: pointer;"
                @click="expandBank(bank)"
              >
                <feather-icon
                  size="16"
                  :icon="bank.cbs_expanded ? 'ChevronDownIcon' : 'ChevronRightIcon'"
                />
              </span>
            </td>
            <td>
              <cbs-budreq-cell
                :record="bank"
                key-value="code"
                value-type="string"
                access="rw"
                :style="pink(`bank_${bank.id.value}_code`, 'text-align: center;')"
                @edit="onEditBank(bank, 'code', $event)"
              />
            </td>
            <td>
              {{ bank.name.value }} ({{ accCount(bank) }})
              <b-badge
                pill
                variant="light-success"
                title="Создать счет"
                style="cursor: pointer;"
                @click="createAcc(bank)"
              >
                +
              </b-badge>
            </td>
            <td />
            <td />
            <td />
            <td style="text-align: right;">
              {{ amountKztBank(bank).toLocaleString() }}
            </td>
            <td />
            <td />
            <td />
            <td>
              <cbs-budreq-cell
                :record="bank"
                key-value="ratingsnp"
                value-type="string"
                access="rw"
                :style="pink(`bank_${bank.id.value}_ratingsnp`, 'text-align: left;')"
                @edit="onEditBank(bank, 'ratingsnp', $event)"
              />
            </td>
            <td />
            <td>
              <cbs-budreq-cell
                :record="bank"
                key-value="descr"
                value-type="string"
                access="rw"
                :style="pink(`bank_${bank.id.value}_descr`, 'text-align: left;')"
                @edit="onEditBank(bank, 'descr', $event)"
              />
            </td>
          </tr>
          <tr
            v-for="acc in accounts_and_deposits(bank)"
            :key="`${acc.id.value}_${acc.isDeposit}`"
            :style="acc.isDeposit?'opacity: 0.7':''"
          >
            <td style="text-align: right;">
              {{ acc.id.value }}
            </td>
            <td>
              <cbs-budreq-cell
                :record="acc"
                key-value="code"
                value-type="string"
                :access="acc.isDeposit? 'ro': 'rw'"
                :style="pink(`acc_${acc.id.value}_code`, 'text-align: center;', acc.isDeposit)"
                @edit="onEditAcc(acc, 'code', $event)"
              />
            </td>
            <td>
              <cbs-budreq-cell
                :record="acc"
                key-value="name"
                value-type="string"
                :access="acc.isDeposit? 'ro': 'rw'"
                :style="pink(`acc_${acc.id.value}_name`, 'text-align: right;', acc.isDeposit)"
                @edit="onEditAcc(acc, 'name', $event)"
              />
            </td>
            <td style="text-align: center;">
              <template v-if="acc.isDeposit">
                Депозит
              </template>
              <template v-else>
                <cbs-reference-picker3
                  :record="acc"
                  :field="qryAcc.columns.find(c => c.entitysid === 'tres_acc_type')"
                  :style="pink(`acc_${acc.id.value}_tres_acc_type`, '', acc.isDeposit)"
                  :prop-ref="refAccType()"
                  :key-mode="'sid'"
                  @updateCell="onEditAcc(acc, 'tres_acc_type', $event)"
                />
              </template>
            </td>
            <td style="text-align: center;">
              <template v-if="acc.isDeposit">
                {{ acc.currency.title }}
              </template>
              <template v-else>
                <cbs-reference-picker3
                  :record="acc"
                  :field="qryAcc.columns.find(c => c.entitysid === 'currency')"
                  :style="pink(`acc_${acc.id.value}_currency`, '', acc.isDeposit)"
                  :prop-ref="refCur()"
                  :key-mode="'sid'"
                  @updateCell="onEditAcc(acc, 'currency', $event)"
                />
              </template>
            </td>
            <td
              style="padding: 0.5rem;"
              :style="isProtected() || acc.isDeposit ? '' : 'background-color: lightyellow;'"
            >
              <div
                v-if="acc.isDeposit"
                style="text-align: right;"
              >
                {{ formatNumber(acc.curamount.value) }}
              </div>
              <template v-else>
                <cbs-budreq-cell
                  :record="getRecord(acc)"
                  key-value="curamount"
                  value-type="number"
                  :access="isProtected()? 'ro' : 'rw'"
                  style="text-align: right;"
                  :style="pink(`saldo_${acc.id.value}`, 'text-align: right;', acc.isDeposit)"
                  @edit="onEditSaldo(acc, $event)"
                />
              </template>
            </td>
            <td style="text-align: right;">
              <template v-if="acc.isDeposit">
                {{ amountKzt(acc.currency.value, acc.curamount.value).toLocaleString() }}
              </template>
              <template v-else>
                {{ amountKzt(acc.currency.value, getRecord(acc).curamount.value).toLocaleString() }}
              </template>
            </td>
            <td>
              <cbs-budreq-cell
                :record="acc"
                key-value="fld_rate"
                value-type="percent"
                :access="acc.isDeposit? 'ro': 'rw'"
                :style="pink(`acc_${acc.id.value}_fld_rate`, 'text-align: center;', acc.isDeposit)"
                @edit="onEditAcc(acc, 'fld_rate', $event)"
              />
            </td>
            <td>
              <cbs-budreq-cell
                :record="acc"
                key-value="start"
                value-type="date"
                :access="acc.isDeposit? 'ro': 'rw'"
                :style="pink(`acc_${acc.id.value}_start`, 'text-align: center;', acc.isDeposit)"
                @edit="onEditAcc(acc, 'start', $event)"
              />
            </td>
            <td>
              <cbs-budreq-cell
                :record="acc"
                key-value="finish"
                value-type="date"
                :access="acc.isDeposit? 'ro': 'rw'"
                :style="pink(`acc_${acc.id.value}_finish`, 'text-align: center;', acc.isDeposit)"
                @edit="onEditAcc(acc, 'finish', $event)"
              />
            </td>
            <td />
            <td>
              <cbs-budreq-cell
                v-if="!acc.isDeposit"
                :record="acc"
                key-value="iban"
                value-type="string"
                :access="acc.isDeposit? 'ro': 'rw'"
                :style="pink(`acc_${acc.id.value}_iban`, 'text-align: center;', acc.isDeposit)"
                @edit="onEditAcc(acc, 'iban', $event)"
              />
            </td>
            <td>
              <cbs-budreq-cell
                :record="acc"
                key-value="descr"
                value-type="string"
                :access="acc.isDeposit? 'ro': 'rw'"
                :style="pink(`acc_${acc.id.value}_descr`, 'text-align: left;', acc.isDeposit)"
                @edit="onEditAcc(acc, 'descr', $event)"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <cbs-debug
      v-if="isRoot"
      :context="this"
    />
  </div>
</template>

<script>

import Vue from 'vue'
import { Calendar, setupCalendar } from 'v-calendar'
import 'v-calendar/lib/v-calendar.min.css'
import CbsDebug from '@/cubus/components/debug/CbsDebug.vue'
import useCubus from '@/cubus/services/useCubus'
import {
  BBadge, BButton, BFormDatepicker, BFormInput, BInputGroup, BInputGroupAppend,
} from 'bootstrap-vue'
import CbsBudreqCell from '@/cubus/components/cbs-form/custom-forms/budget-request/CbsBudreqCell.vue'
import CbsReferencePicker3 from '@/cubus/components/reference/CbsReferencePicker3.vue'
import Swal from 'sweetalert2'
import Q from '@/cubus/services/Q'

setupCalendar({
  firstDayOfWeek: 2,
})

Vue.component('v-calendar', Calendar)

export default {
  name: 'CbsTresSaldoIn',
  components: {
    BBadge,
    CbsReferencePicker3,
    CbsBudreqCell,
    CbsDebug,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BFormDatepicker,
    BButton,
  },
  props: {
    saldoOut: {
      type: Boolean,
      default: false,
    },
    objectFull: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      uuid: null,
      date: null,
      selectedDate: null,
      qryBank: null,
      qryAcc: null,
      qryRates: null,
      qrySaldo: null,
      qryDeposits: null,
      qryAccType: null,
      qryCur: null,
      ratesReady: false,
      filledDates: [],
      closestFilledDate: undefined,
      cache: [],
      changedElements: [],
      loadingRates: false,
      loadingData: true,
      attrs: [
        {
          key: 'today',
          highlight: {
            backgroundColor: '#ff808033',
          },
          dates: new Date(),
        },
        {
          key: 'filled-dates',
          highlight: {
            backgroundColor: '#35A7FF',
            borderRadius: '50%',
          },
          dates: [],
        },
        {
          key: 'selected-date',
          highlight: {
            backgroundColor: '#4CAF50',
            borderRadius: '50%',
          },
          dates: [],
        },
      ],
      dataReady: false,
    }
  },
  setup() {
    return {
      isRoot: useCubus.isRoot(),
      notDelCond: useCubus.cond_notDel(),
      notDelFilter: useCubus.filter_notDel(),
      orderByCode: useCubus.orderby_code(),
    }
  },
  watch: {
    date(newVal, oldVal) {
      this.initData()
    },
  },
  created() {
    this.uuid = useCubus.guid()
    this.init()
  },
  methods: {
    async init() {
      await this.initDate()
      await this.initData()
    },
    initDate() {
      const d = new Date()
      // if (this.saldoOut) d.setDate(d.getDate())
      this.date = d.toISOString().split('T')[0]
      this.onDayClick({ date: d })
    },
    async initData() {
      this.dataReady = false
      this.cache = []
      this.changedElements = []
      this.loadingData = true
      this.loadingRates = true
      await this.initRates()
      this.loadingRates = false
      await this.loadAccTypes()
      await this.loadCurrencies()
      await this.loadQryBank()
      await this.loadAccounts()
      await this.loadSaldo()
      await this.loadDeposits()
      await this.loadFilledDates()
      this.loadingData = false
      this.dataReady = true
    },
    async initRates() {
      await this.loadRates()
      if (this.qryRates.recordset.records.length === 0) {
        await this.loadNbRkRates()
        await this.loadRates()
      }
      this.ratesReady = true
    },
    async loadRates() {
      this.qryRates = await useCubus.loadQuery(this, {
        keymode: 'sid',
        objectsid: 'nbrkcurrates',
        filter: Q.and([
          Q.equals('del', false),
          Q.equals('date', this.selectedDate),
          Q.isNotNull('currency'),
        ]),
        orderby: Q.orderBy('curname'),
        limit: 1000,
      })
    },
    async loadNbRkRates() {
      await useCubus.runProcedure(this, {
        keymode: 'sid',
        objectsid: 'procgetcurratesnbrkdate',
        record: {
          start: { value: this.date, title: null },
          finish: { value: this.date, title: null },
        },
      })
    },
    async loadAccTypes() {
      this.qryAccType = await useCubus.loadQuery(this, {
        keymode: 'sid',
        objectsid: 'tres_acc_type',
        filter: this.notDelFilter,
        orderby: this.orderByCode,
        limit: 1000,
      })
    },
    async loadCurrencies() {
      this.qryCur = await useCubus.loadQuery(this, {
        keymode: 'sid',
        objectsid: 'currency',
        filter: this.notDelFilter,
        orderby: this.orderByCode,
        limit: 1000,
      })
    },
    async loadQryBank() {
      this.qryBank = await useCubus.loadQuery(this, {
        keymode: 'sid',
        objectsid: 'tres_bank',
        filter: this.notDelFilter,
        orderby: this.orderByCode,
        limit: 1000,
      })
    },
    async loadFilledDates(otherDate = null) {
      let date = new Date(this.selectedDate)
      if (otherDate) {
        date = otherDate
      }
      const startDate = new Date(date)
      startDate.setMonth(startDate.getMonth() - 1)
      const formattedStartDate = startDate.toISOString().split('T')[0]

      const finishDate = new Date(date)
      finishDate.setMonth(finishDate.getMonth() + 1)
      const formattedFinishDate = finishDate.toISOString().split('T')[0]

      const filledDates = await useCubus.loadQuery(this, {
        keymode: 'sid',
        objectsid: 'tres_saldo_in',
        filter: Q.and([
          this.notDelCond,
          Q.notless('date', formattedStartDate),
          Q.notgreater('date', formattedFinishDate),
        ]),
        groupby: Q.groupBy(
          ['date', 'day'],
        ),
        limit: 10000,
      })
      this.filledDates = filledDates.recordset.records.map(record => {
        const d = new Date(record.date.value)
        if (this.saldoOut) d.setDate(d.getDate() - 1)
        return d.toISOString().split('T')[0]
      })
      this.closestFilledDate = this.filledDates
        .filter(date => date <= this.selectedDate.toISOString().split('T')[0])
        .sort((a, b) => new Date(b) - new Date(a))[0]
      this.attrs.find(attr => attr.key === 'filled-dates').dates = this.filledDates
    },
    async loadAccounts() {
      this.qryAcc = await useCubus.loadQuery(this, {
        keymode: 'sid',
        objectsid: 'tres_account',
        filter: this.notDelFilter,
        orderby: this.orderByCode,
        limit: 1000,
      })
    },
    async loadSaldoForDate(date) {
      return useCubus.loadQuery(this, {
        keymode: 'sid',
        objectsid: 'tres_saldo_in',
        filter: Q.and([
          this.notDelCond,
          Q.equals('date', date),
        ]),
        limit: 1000,
      })
    },
    async loadSaldo() {
      this.qrySaldo = await this.loadSaldoForDate(this.date)
    },
    async loadDeposits() {
      let prm = {
        keymode: 'sid',
        objectsid: 'tres_deposit',
        filter: Q.and([
          this.notDelCond,
          Q.notgreater('start', this.date),
          Q.notless('finish', this.date),
        ]),
        limit: 1000,
      }
      if (this.saldoOut) {
        prm = {
          keymode: 'sid',
          objectsid: 'tres_deposit',
          filter: Q.and([
            this.notDelCond,
            Q.less('start', this.date),
            Q.greater('finish', this.getPrevDay(this.date)),
          ]),
          limit: 1000,
        }
      }
      /*
      this.qryDeposits = await useCubus.loadQuery(this, {
        keymode: 'sid',
        objectsid: 'tres_deposit',
        filter: Q.and([
          this.notDelCond,
          Q.notgreater('start', this.date),
          Q.notless('finish', this.date),
        ]),
        limit: 1000,
      })
      */
      this.qryDeposits = await useCubus.loadQuery(this, prm)
      /*
      for (const rec of this.qryDeposits.recordset.records) {
        rec.curamount = rec.deposit_amount_cur
      }
      */
      this.qryDeposits.recordset.records.forEach(rec => {
        const r = rec
        r.curamount = rec.deposit_amount_cur
      })
    },
    closestFilledDateHuman() {
      const closestFilledDate = new Date(this.closestFilledDate)
      // format as DD.MM.YY
      const dd = String(closestFilledDate.getDate()).padStart(2, '0')
      const mm = String(closestFilledDate.getMonth() + 1).padStart(2, '0')
      const yyyy = closestFilledDate.getFullYear()
      return `${dd}.${mm}.${yyyy}`
    },
    async copySaldoFromPreviousDate() {
      if (!this.closestFilledDate) {
        await Swal.fire('Ошибка', 'Нет данных для копирования.', 'error')
        return
      }

      const result = await Swal.fire({
        title: 'Перенести остатки',
        text: `Перенести остатки с даты ${this.closestFilledDate}?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
      })

      if (!result.isConfirmed) return

      let { closestFilledDate } = this
      if (this.saldoOut) {
        const nextDay = new Date(closestFilledDate)
        nextDay.setDate(nextDay.getDate() + 1)
        closestFilledDate = nextDay.toISOString().split('T')[0]
      }
      const oldSaldo = await this.loadSaldoForDate(closestFilledDate)

      for (const rec of oldSaldo.recordset.records) {
        const acc = this.qryAcc.recordset.records.find(r => r.id.value === rec.tres_account.value)
        this.onEditSaldo(acc, rec.curamount.value)
        const bank = this.qryBank.recordset.records.find(r => r.id.value === acc.tres_bank.value)
        bank.cbs_expanded = true
      }

      await Swal.fire('Готово', 'Остатки перенесены', 'success')
    },
    expandBank(bank) {
      if (!('cbs_expanded' in bank)) {
        this.$set(bank, 'cbs_expanded', true)
      } else {
        const b = bank
        b.cbs_expanded = !bank.cbs_expanded
      }
    },
    accounts(bank) {
      if (!bank.cbs_expanded) return []
      return this.qryAcc.recordset.records.filter(r => r.tres_bank.value === bank.id.value).sort((a, b) => a.code.value.localeCompare(b.code.value))
    },
    deposits(bank) {
      if (!bank.cbs_expanded) return []
      return this.qryDeposits.recordset.records.filter(r => r.tres_bank.value === bank.id.value).sort((a, b) => a.code.value.localeCompare(b.code.value))
    },
    accounts_and_deposits(bank) {
      const accounts = this.accounts(bank).map(acc => ({ ...acc, isDeposit: false }))
      const deposits = this.deposits(bank).map(dep => ({ ...dep, isDeposit: true }))
      return [...accounts, ...deposits]
    },
    accCount(bank) {
      return this.qryAcc.recordset.records.filter(r => r.tres_bank.value === bank.id.value).length
    },
    getRecord(acc) {
      const rec = this.qrySaldo.recordset.records.find(r => r.tres_account.value === acc.id.value)
      if (acc.isDeposit) {
        return acc
      }
      if (rec) return rec
      const n = this.getNewRecord(acc)
      this.qrySaldo.recordset.records.push(n)
      return n
    },
    getNewRecord(acc) {
      const n = {}
      this.qrySaldo.columns.forEach(col => {
        if (col.key !== 'actions') {
          n[col.entitysid] = {}
          n[col.entitysid].value = col.default.value
          n[col.entitysid].title = col.default.title
        }
      })
      n.id.value = null
      n.id.title = null
      n.sid.value = `${useCubus.guid()}`
      n.sid.title = null
      /*
      if (this.saldoOut) {
        const d = new Date(this.date)
        d.setDate(d.getDate() + 1)
        n.date.value = d
      } else {
        n.date.value = this.date
      }
      */
      n.date.value = this.date
      n.date.title = null
      n.tres_account.value = acc.id.value
      n.tres_account.title = acc.name.value
      return n
    },

    onEditSaldo(acc, newValue) {
      const rec = this.getRecord(acc)
      const b = rec
      b.curamount.value = newValue
      b.curamount.status = 'changed'
      this.addToCacheSid(rec, 'tres_saldo_in')
      this.addToChangedElements(`saldo_${acc.id.value}`)
    },

    async addToChangedElements(record) {
      this.changedElements.push(record)
    },

    pink(record, defaultStyle, disable = false) {
      if (!disable && this.changedElements.includes(record)) {
        return `${defaultStyle}background-color: pink`
      }
      return defaultStyle
    },

    async addToCacheSid(record, objectSid) {
      this.cache.push({
        record,
        objectSid,
      })
    },

    async wait(sec) {
      return new Promise(resolve => {
        setTimeout(() => {
          resolve()
        }, sec * 1000)
      })
    },

    async saveCache() {
      const total = this.cache.length
      let savedCount = 0
      Swal.fire({
        title: 'Сохранение...',
        text: 'Пожалуйста, подождите',
        html: `<div id="swal-progress">0 / ${total}</div>
           <div style="margin-top: 0.5rem; background: #eee; height: 8px; width: 100%;">
             <div id="swal-bar" style="height: 100%; width: 0%; background: #28a745;"></div>
           </div>`,
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading()
        },
      })
      for (const item of [...this.cache]) {
        const result = await this.saveRecordSid(item.record, item.objectSid)
        if (result === '') {
          savedCount++
          const swalProgress = document.getElementById('swal-progress')
          if (swalProgress) {
            swalProgress.innerHTML = `${savedCount} / ${total}`
          }
          const index = this.cache.indexOf(item)
          if (index !== -1) {
            this.cache.splice(index, 1)
            this.changedElements.splice(index, 1)
          }
        } else {
          await Swal.close()
          await Swal.fire(
            'Ошибка',
            `Не удалось сохранить запись для sid ${item.objectSid}: ${result}`,
            'error',
          )
          throw new Error(`Failed to save record for sid ${item.objectSid}: ${result}`)
        }
      }
      await this.wait(1)
      await Swal.close()
      await Swal.fire(
        'Сохранено',
        'Записи успешно сохранены',
        'success',
      )
    },

    async saveRecordSid(record, objectSid) {
      const params = { keymode: 'sid', objectsid: objectSid, record }
      try {
        const saved = await useCubus.saveRecord(this, params)
        if (objectSid.includes('saldo')) this.afterSaveSaldo(record, saved)
        if (objectSid.includes('bank')) this.afterSaveBank(record, saved)
        if (objectSid.includes('account')) this.afterSaveAcc(record, saved)
        return ''
      } catch (e) {
        console.error(e)
        return e.toString()
      }
    },

    afterSaveSaldo(initRec, savedRec) {
      const i = initRec
      const s = savedRec
      s.status = 'saved'
      this.qrySaldo.columns.filter(c => c.key !== 'actions').forEach(fld => {
        i[fld.entitysid].value = savedRec[fld.entitysid].value
        i[fld.entitysid].title = savedRec[fld.entitysid].title
      })
      i.status = 'saved'
      this.recalc()
    },

    onEditAcc(acc, key, newValue) {
      const b = acc
      if (key === 'tres_acc_type' || key === 'currency') {
        b[key].value = newValue.value
        b[key].title = newValue.title
        b[key].status = 'changed'
      } else if (key === 'fld_rate') {
        if (newValue === '') {
          b[key].value = null
        } else {
          b[key].value = newValue
        }
        b[key].status = 'changed'
        b[key].value = newValue
        b[key].status = 'changed'
      } else {
        b[key].value = newValue
        b[key].status = 'changed'
      }
      this.addToCacheSid(acc, 'tres_account')
      this.addToChangedElements(`acc_${acc.id.value}_${key}`)
    },
    afterSaveAcc(initRec, savedRec) {
      const i = initRec
      const s = savedRec
      s.status = 'saved'
      this.qryAcc.columns.filter(c => c.key !== 'actions').forEach(fld => {
        i[fld.entitysid].value = savedRec[fld.entitysid].value
        i[fld.entitysid].title = savedRec[fld.entitysid].title
        i[fld.entitysid].status = 'saved'
      })
      i.status = 'saved'
      this.recalc()
    },

    onEditBank(rec, key, newValue) {
      const b = rec
      b[key].value = newValue
      b[key].status = 'changed'
      this.addToCacheSid(rec, 'tres_bank')
      this.addToChangedElements(`bank_${rec.id.value}_${key}`)
    },

    afterSaveBank(initRec, savedRec) {
      const i = initRec
      const s = savedRec
      if (s) s.status = 'saved'
      this.qryBank.columns.filter(c => c.key !== 'actions').forEach(fld => {
        i[fld.entitysid].value = savedRec[fld.entitysid].value
        i[fld.entitysid].title = savedRec[fld.entitysid].title
      })
      if (i) i.status = 'saved'
      this.recalc()
    },

    recalc() {
      console.log('recalc')
    },
    refAccType() {
      return this.qryAccType.recordset.records.map(r => ({ value: r.id.value, title: r.name.value }))
    },
    refCur() {
      return this.qryCur.recordset.records.map(r => ({ value: r.id.value, title: r.name.value }))
    },
    async createAcc(bank) {
      const result = await Swal.fire(
        {
          title: 'Создать новый счет',
          text: `Вы уверены, что хотите создать новый счет для банка ${bank.name.value}?`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Да',
          cancelButtonText: 'Нет',
        },
      )
      if (!result.isConfirmed) return
      const n = {}
      this.qryAcc.columns.forEach(col => {
        if (col.key !== 'actions') {
          n[col.entitysid] = {}
          n[col.entitysid].value = col.default.value
          n[col.entitysid].title = col.default.title
        }
      })
      n.id.value = null
      n.id.title = null
      n.sid.value = `${useCubus.guid()}`
      n.sid.title = null
      n.code.value = `${bank.code.value}.${String(this.accCount(bank) + 1).padStart(2, '0')}`
      n.code.title = null
      n.tres_bank.value = bank.id.value
      n.tres_bank.title = bank.name.value
      this.qryAcc.recordset.records.push(n)
      await Swal.fire(
        'Создано',
        `Счет ${n.code.value} успешно создан.`,
        'success',
      )
    },

    curRate(curid) {
      const rate = this.qryRates.recordset.records.find(r => r.currency.value === curid)
      if (rate) return rate.fxrate.value
      return 1
    },
    amountKzt(curid, curamount) {
      return (curamount || 0) * this.curRate(curid)
    },
    amountCurAcc(acc) {
      let rec = this.qrySaldo.recordset.records.find(r => r.tres_account.value === acc.id.value)
      if (acc.isDeposit) rec = this.qryDeposits.recordset.records.find(r => r.tres_account.value === acc.id.value)
      if (rec) {
        return rec.curamount.value || 0
      }
      return 0
    },
    amountKztAcc(acc) {
      /*
      let rec = this.qrySaldo.recordset.records.find(r => r.tres_account.value === acc.id.value)
      if (acc.isDeposit) {
        rec = this.qryDeposits.recordset.records.find(r => r.tres_account.value === acc.id.value)
      }
      if (rec) {
        return this.amountKzt(acc.currency.value, rec.curamount.value)
      }
      */

      if (acc.isDeposit) {
        console.log('t', this.amountKzt(acc.currency.value, acc.curamount.value))
        return this.amountKzt(acc.currency.value, acc.curamount.value)
      }
      const saldo = this.qrySaldo.recordset.records.find(r => r.tres_account.value === acc.id.value)
      if (saldo) {
        return this.amountKzt(acc.currency.value, saldo.curamount.value)
      }
      return 0
    },
    amountKztDep(dep) {
      return this.amountKzt(dep.currency.value, dep.curamount.value)
    },
    amountKztBank(bank) {
      const accTotal = this.qryAcc.recordset.records
        .filter(r => r.tres_bank.value === bank.id.value)
        .reduce((acc, crs) => acc + this.amountKztAcc(crs), 0)

      const depTotal = this.qryDeposits.recordset.records
        .filter(r => r.tres_bank.value === bank.id.value)
        .reduce((acc, crs) => acc + this.amountKztDep(crs), 0)
      console.log(`depTotal : ${bank.name.value} = ${depTotal}`)

      return accTotal + depTotal
    },
    totalAmountCur(curid) {
      const acc = this.qryAcc.recordset.records
        .filter(r => r.currency.value === curid)
        .reduce((a, crs) => a + this.amountCurAcc(crs), 0)

      const dep = this.qryDeposits.recordset.records
        .filter(r => r.currency.value === curid)
        .reduce((d, crs) => d + crs.deposit_amount_cur.value, 0)

      return acc + dep
    },
    totalAmountCurKzt(curid) {
      return this.totalAmountCur(curid) * this.curRate(curid)
    },
    totalAmountCurUsd(curid) {
      const usd = this.qryCur.recordset.records.find(r => r.code.value === 'USD')
      return this.totalAmountCurKzt(curid) / this.curRate(usd.id.value)
    },
    totalAmountKzt() {
      return this.qryCur.recordset.records
        .reduce((acc, cur) => acc + this.totalAmountCurKzt(cur.id.value), 0)
    },
    totalAmountUsd() {
      return this.qryCur.recordset.records
        .reduce((acc, cur) => acc + this.totalAmountCurUsd(cur.id.value), 0)
    },

    kztRate() {
      const kzt = this.qryCur.recordset.records.find(r => r.code.value === 'KZT')
      return {
        curname: { value: 'KZT', title: null },
        currency: { value: kzt.id.value, title: kzt.name.value },
        date: { value: this.date, title: null },
        fxrate: { value: 1, title: null },
        id: { value: null, title: null },
        sid: { value: null, title: null },
        del: { value: false, title: null },
      }
    },
    currencies() {
      return [...this.qryRates.recordset.records, this.kztRate()]
    },

    async onMonthChange(page) {
      const newDate = new Date(page.year, page.month - 1, 1)
      await this.loadFilledDates(newDate)
    },
    async checkAndSave() {
      if (this.cache.length > 0) {
        const result = await Swal.fire(
          {
            title: 'Сохранить изменения?',
            text: 'У вас есть несохраненные изменения. Вы хотите сохранить их?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Да',
            cancelButtonText: 'Нет',
          },
        )
        if (result.isConfirmed) {
          await this.saveCache()
        } else {
          this.cache = []
          this.changedElements = []
        }
      }
    },
    async onDayClick(day) {
      await this.checkAndSave()
      const localDate = new Date(day.date)
      if (this.saldoOut) localDate.setDate(localDate.getDate() + 1)
      localDate.setHours(12, 0, 0, 0)
      const selectedDate = new Date(day.date)
      selectedDate.setHours(12, 0, 0, 0)
      this.selectedDate = selectedDate
      this.date = localDate.toISOString().split('T')[0]
      this.attrs.find(attr => attr.key === 'selected-date').dates = [selectedDate]
      await this.loadFilledDates()
    },

    async deleteSaldo() {
      const result = await Swal.fire(
        {
          title: 'Удалить остатки',
          text: 'Вы уверены, что хотите удалить остатки за день?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Да',
          cancelButtonText: 'Нет',
        },
      )
      if (!result.isConfirmed) return
      await useCubus.runMount(this, {
        objectsid: 'mount_tres_delete_saldo',
        keymode: 'sid',
        record: {
          date: { value: this.date, title: null },
        },
      })
      await this.init()
      await Swal.fire(
        'Удалено',
        'Остатки за день удалены.',
        'success',
      )
    },

    isProtected() {
      return this.qrySaldo.recordset.records.some(r => r.protected.value)
    },
    hasSavedSaldo() {
      return this.qrySaldo.recordset.records.some(r => r.id.value !== null && r.id.value > 0)
    },

    async protectSaldo() {
      await this.checkAndSave()
      await useCubus.runMount(this, {
        objectsid: 'mount_tres_protect_saldo',
        keymode: 'sid',
        record: {
          date: { value: this.date, title: null },
        },
      })
      this.loadSaldo()
    },
    async unprotectSaldo() {
      await useCubus.runMount(this, {
        objectsid: 'mount_tres_unprotect_saldo',
        keymode: 'sid',
        record: {
          date: { value: this.date, title: null },
        },
      })
      this.loadSaldo()
    },

    formatNumber(value) {
      return new Intl.NumberFormat('ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(value))
    },

    getNextDay(dt) {
      return this.addDays(dt, 1)
    },
    getPrevDay(dt) {
      return this.addDays(dt, -1)
    },
    addDays(dt, days) {
      const nextDay = new Date(dt)
      nextDay.setDate(nextDay.getDate() + days)
      return nextDay
    },
  },
}
</script>

<style scoped>
.tbl > thead > tr > th {
  padding: 0.5rem 1rem 0.5rem 1rem;
}

.tbl > tbody > tr > td {
  padding: 0.5rem 1rem 0.5rem 1rem;
}
</style>
